// Lettura del contenuto trasportato da un drag & drop.
//
// NON usare `getData(event.dataTransfer.types)`: `types` e' una LISTA di formati,
// mentre `getData()` accetta il nome di UN formato. La conversione implicita
// funziona solo finche' la lista ha un elemento solo, e i browser aggiungono
// tipi interni propri (es. `chromium/x-drag-id`) che la fanno crescere.
// Qui il formato viene sempre cercato per nome e tutto il resto ignorato.

// Formati impostati da DraggableItem, che usa classProperties.type come formato.
export const FORM_EDITOR_FORMATS = ['form-widget', 'form-layout'];
export const REPORT_EDITOR_FORMATS = ['widget-instance'];

export const readDragPayload = (event, acceptedFormats) => {
    const dt = event.dataTransfer;
    if (!dt) return null;

    const format = acceptedFormats.find((accepted) => dt.types.includes(accepted));
    if (!format) return null;

    const raw = dt.getData(format);
    if (!raw) return null;

    try {
        return JSON.parse(raw);
    } catch (error) {
        console.warn('DRAG PAYLOAD: contenuto non valido per il formato', format, error);
        return null;
    }
};
